export class User{
	constructor(
		public id: number,
		public email: string,
		public password: string,
		public name: string,
		public last_name: string,
		public img: string,
		public recuerdame: boolean
	){}
}
